import type { ExcludeReadingOrderCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useCreateExcludeReadingOrderFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: ExcludeReadingOrderCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function ExcludeReadingOrderCreationPanel({
  fragment,
  onDelete,
}: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateExcludeReadingOrderFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("ExcludeReadingOrderCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
